import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IBasketResponse } from './IBasketResponse';

export const updateOrderPoNumber = (poNumber: string): AxiosPromise<IBasketResponse> => {
  return Fetch().then(axios => axios.post('orders/update-po-number', { PoNumber: poNumber }));
};
